import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchCoupons = createAsyncThunk(
  "coupons/fetchCoupons",
  async () => {
    const response = await apiCustom.get("coupons-show");
    return response.data?.data?.data;
  }
);
export const createCoupons = createAsyncThunk(
  "coupons/createCoupons",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/coupon-create", newPost, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updateCoupons = createAsyncThunk(
  "coupons/updateCoupons",
  async ({ id, newPost }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/coupon-update/${id}`, newPost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const deleteCoupons = createAsyncThunk(
  "coupons/deleteCoupons",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete(`/coupon-delete/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

const couponsSlice = createSlice({
  name: "coupons",
  initialState: {
    coupons: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCoupons.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCoupons.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.coupons = action.payload;
      })
      .addCase(fetchCoupons.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createCoupons.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(deleteCoupons.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(updateCoupons.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});

export default couponsSlice.reducer;
